import PropTypes from 'prop-types'
import React, { createContext, forwardRef, useState } from 'react'
import { SidenavBody } from './sidenav-body'
// eslint-disable-next-line import/no-cycle
import { SidenavItem } from './sidenav-item'
// eslint-disable-next-line import/no-cycle
import SidenavLink from './sidenav-link'
import { SidenavSection } from './sidenav-section'

export const SidenavContext = createContext({
  currentPath: {},
  setCurrentPath: () => {},
})

export const Sidenav = forwardRef((props, ref) => {
  const [currentPath, setCurrentPath] = useState({})
  const { as = 'aside', children, ...rest } = props
  const context = { currentPath, setCurrentPath }
  const Component = as

  return (
    <SidenavContext.Provider value={context}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child
        return (
          <Component
            className="dev_dash__sidenav--container"
            ref={ref}
            {...rest}
          >
            {child}
          </Component>
        )
      })}
    </SidenavContext.Provider>
  )
})

Sidenav.Body = SidenavBody
Sidenav.Item = SidenavItem
Sidenav.Link = SidenavLink
Sidenav.Section = SidenavSection

Sidenav.displayName = 'Sidenav'

Sidenav.propTypes = {
  as: PropTypes.any,
  children: PropTypes.element.isRequired,
}
